window.addEventListener('load', () => {
    console.log("Menu plugin loaded");
    const toggles = document.querySelectorAll("[data-nav-menu-toggle]");

    const body_toggle_class = "mobile-menu-open";

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
            document.body.classList.toggle(body_toggle_class);
        });
    });

});
